export const ROUTES = {
  // Public
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  SELLER_SIGNUP: '/seller-signup',
  RESET_PASSWORD: '/reset-password',
  BOOKS: '/books',
  BOOK_DETAILS: (id: string) => `/book/${id}`,
  CATEGORY: (category: string) => `/category/${category}`,
  SEARCH: '/search',
  CART: '/cart',
  SELLER_GUIDE: '/seller-guide',
  FAQ: '/faq',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  DELETE_DATA: '/privacy/delete-data',
  REPORT_CONTENT: '/report-content',
  SUPPORT: '/support',

  // Buyer (Auth Required)
  DASHBOARD: '/dashboard',
  CHECKOUT: '/checkout',
  ORDER_CONFIRMATION: '/order-confirmation',
  ORDERS: '/orders',
  ORDER_DETAILS: (id: string) => `/order/${id}`,
  BUYER_UPGRADE: '/buyer-upgrade',

  // Seller
  SELL: '/sell',
  EDIT_BOOK: (id: string) => `/edit-book/${id}`,
  SELLER_SETTINGS: '/seller-settings',

  // Admin
  ADMIN: '/admin',
  // Admin-only Delhivery rate/serviceability tools (guarded by AdminGuard in App.tsx).
  SHIPPING: '/shipping',
} as const;
